import * as yup from 'yup'

const schema = (selectExistentResponsible) => {
  if (selectExistentResponsible) {
    return yup.object().shape({
      responsibleDpo: yup.object().required(),
    })
  }

  return yup.object().shape({
    responsibleName: yup.string().required(),
    responsibleEmail: yup.string().required(),
  })
}

export default schema
